export default class MouseStalker {
  constructor() {
    this.DOM = {}
    this.DOM.html      = document.querySelector( 'html.pc' )
    this.DOM.stalker   = document.getElementById( 'js-mouse-stalker' )
    this.DOM.linkMore  = document.querySelectorAll( '[data-link*="more"]' )
    this.DOM.linkPoint = document.querySelectorAll( '[data-link*="point"]' )
    this.DOM.linkPlay = document.querySelectorAll( '[data-link*="play"]' )
    this.DOM.linkZoom = document.querySelectorAll( '[data-link*="zoom"]' )
    this.DOM.linkPlus = document.querySelectorAll( '[data-link*="plus"]' )

    this._stalkerEvent()
    this._linkEvent()
    this._linkPoint()
    this._linkPlay()
    this._linkZoom()
    this._linkPlus()
  }

  _stalkerEvent() {
    if ( !this.DOM.stalker || !this.DOM.html ) {
      return
    }

    document.addEventListener( 'mousemove', e => {
      let cx = e.clientX
      let cy = e.clientY
      this.DOM.stalker.style.transform = `translate3d(${ cx }px, ${ cy }px, 0)`
    })
  }

  _linkEvent() {
    if ( !this.DOM.linkMore || !this.DOM.html ) {
      return
    }

    ;[].forEach.call( this.DOM.linkMore, more => {
      more.addEventListener( 'mouseenter', e => {
        this.DOM.stalker.classList.add('view-more')
      })
      more.addEventListener( 'mouseleave', e => {
        this.DOM.stalker.classList.remove('view-more')
      })
    })
  }

  _linkPoint() {
    if ( !this.DOM.linkPoint || !this.DOM.html ) {
      return
    }

    ;[].forEach.call( this.DOM.linkPoint, more => {
      more.addEventListener( 'mouseenter', e => {
        this.DOM.stalker.classList.add('view-point')
      })
      more.addEventListener( 'mouseleave', e => {
        this.DOM.stalker.classList.remove('view-point')
      })
    })
  }

  _linkPlay() {
    if ( !this.DOM.linkPlay || !this.DOM.html ) {
      return
    }

    ;[].forEach.call( this.DOM.linkPlay, more => {
      more.addEventListener( 'mouseenter', e => {
        this.DOM.stalker.classList.add('view-play')
      })
      more.addEventListener( 'mouseleave', e => {
        this.DOM.stalker.classList.remove('view-play')
      })
    })
  }

  _linkZoom() {
    if ( !this.DOM.linkZoom || !this.DOM.html ) {
      return
    }

    ;[].forEach.call( this.DOM.linkZoom, more => {
      more.addEventListener( 'mouseenter', e => {
        this.DOM.stalker.classList.add('view-zoom')
      })
      more.addEventListener( 'mouseleave', e => {
        this.DOM.stalker.classList.remove('view-zoom')
      })
    })
  }

  _linkPlus() {
    if ( !this.DOM.linkPlus || !this.DOM.html ) {
      return
    }

    ;[].forEach.call( this.DOM.linkPlus, more => {
      more.addEventListener( 'mouseenter', e => {
        this.DOM.stalker.classList.add('view-plus')
      })
      more.addEventListener( 'mouseleave', e => {
        this.DOM.stalker.classList.remove('view-plus')
      })
    })
  }

}

new MouseStalker()
